import { Storage } from "aws-amplify";

class File {
  static upload(bucket, file, fileName = "") {
    const resolvedFileName = fileName === "" ? file.name : fileName;
    return new Promise((resolve, reject) => {
      Storage.configure({ AWSS3: bucket });
      Storage.put(resolvedFileName, file, {
        contentType: file.type,
        cacheControl: "no-cache",
        qexpires: Date.now() + 3000,
        customPrefix: {
          public: "",
        },
      })
        .then((response) => {
          resolve(response);
        })
        .catch((e) => {
          reject(e);
        });
    });
  }

  static exists(bucket, fileName) {
    return new Promise((resolve) => {
      Storage.configure({ AWSS3: bucket });
      Storage.list(fileName, {
        customPrefix: {
          public: "",
        },
      })
        .then((files) => {
          if (files.length > 0) {
            resolve(true);
          } else {
            resolve(false);
          }
        })
        .catch(() => {
          resolve(false);
        });
    });
  }

  static download(bucket, fileName, progressCallback = () => {}) {
    Storage.configure({ AWSS3: bucket });
    return Storage.get(fileName, {
      progressCallback,
      customPrefix: {
        public: "",
      },
    });
  }
}

export default File;
